import React, {useMemo} from 'react';
import {IScrollingFreeCollectiblesContainer} from '@wearesection/bandai-react-components/organisms/ScrollingFreeCollectiblesContainer';
import {ComponentPropsAdapter} from '../../types';
import {Game, News, NewsListing} from '~/graphql/types';
import {PLACEHOLDER_IMG} from '~/constants';
import RenderNextImage from '../../atoms/render-next-image';
import {useRouter} from 'next/router';
import {Box} from '@mui/material';
import {GetRouter} from '~/utils';
import dynamic from 'next/dynamic';
const ScrollingFreeCollectiblesContainer = dynamic(
  () => import('@wearesection/bandai-react-components/organisms/ScrollingFreeCollectiblesContainer')
);
type IScrollingFreeCollectiblesContainerExt = IScrollingFreeCollectiblesContainer &
  Game &
  NewsListing &
  any & {};

const adapterNewsListing: ComponentPropsAdapter<
  IScrollingFreeCollectiblesContainerExt,
  IScrollingFreeCollectiblesContainer
> = data => {
  const {locale} = GetRouter();
  return {
    title: data?.title,
    description: '',
    classSection: 'thumbnail-card-carousel',
    listThumbnail: data?.listThumbnail?.map((item: News) => {
      return {
        title: item?.title,
        description: item?.shortDescription ?? '',
        mainImage: item?.mainImage?.media?.url ?? PLACEHOLDER_IMG,
        href: item?.slug?.includes('http') ? item?.slug : `/${locale}/news/${item?.slug}`,
        target: '_parent',
      };
    }),
    isShowPopup: false,
  };
};

const handleReturnHrefSocialShare = (locale: string) => {
  switch (locale) {
    case 'zh-Hant':
    case 'zh-Hans':
      return 'https://www.weibo.com/u/5637983127?is_all=1 ';
    case 'ko-kr':
      return 'http://pf.kakao.com/_Wiyxcxb';
    case 'tw-sc':
    case 'tw-tc':
    case 'hk-tc':
    case 'hk-sc':
      return 'https://www.facebook.com/BNETaiwan/';
    default:
      return 'https://www.facebook.com/bandainamcoent.asia/';
  }
};

const adapterHomePage: ComponentPropsAdapter<
  IScrollingFreeCollectiblesContainerExt,
  IScrollingFreeCollectiblesContainer
> = data => {
  const {locale} = GetRouter();
  const host = data?.host || '';
  const newLocales = locale?.toLowerCase();
  let isShowWeibo = false;
  let isShowKakao = false;

  if (
    newLocales === 'hk-tc' ||
    newLocales === 'hk-sc' ||
    newLocales === 'tw-tc' ||
    newLocales === 'tw-sc'
  ) {
    isShowWeibo = true;
  }
  if (newLocales === 'ko-kr') {
    isShowKakao = true;
  }

  return {
    title: data?.title || '',
    description: data?.seeAllText || '',
    classSection: 'thumbnail-card-carousel',
    isShowPopup: false,
    listThumbnail:
      data?.listItemCollection?.items?.map((item: any) => {
        const share = item?.slug?.includes('http') ? item.slug : `${host}/news/${item.slug}`;
        return {
          socialShare: false,
          title: item?.title || '',
          mainImageNext: (
            <Box
              sx={{
                height: '100%',
                '& > span': {
                  height: '100% !important',
                },
              }}
            >
              <RenderNextImage
                src={item?.mainImage?.media?.url ?? PLACEHOLDER_IMG}
                width={357}
                height={200}
                alt={item?.title}
              />
            </Box>
          ),
          href: item?.slug?.includes('http') ? item.slug : `/${locale}/news/${item.slug}`,
          target: '_blank',
          socialShareHref: handleReturnHrefSocialShare(data.locale),
          socialShareProps: {
            title: 'Share this',
            socialShareProps: {
              fbShare: `https://www.facebook.com/sharer/sharer.php?u=${share}`,
              instaShare: `https://www.instagram.com/?url=${share}`,
              twShare: `https://twitter.com/intent/tweet?text=${share}`,
              weiboShare: isShowWeibo
                ? `https://service.weibo.com/share/share.php?url=${share}&title=Share&language=zh_cn#_loginLayer_1662605727516`
                : '',
              kakaoShare: isShowKakao
                ? `https://story.kakao.com/s/share?url=${share}&text=Share&app_key=BLAH2`
                : '',
              hrefShare: true,
            },
          },
        };
      }) || [],
  };
};

const handleTypeName = (props: any) => {
  const typeName: any = {
    HomePageNewListing: adapterHomePage(props),
    NewsListing: adapterNewsListing(props),
  };
  return typeName[props.__typename] || typeName['NewsListing'];
};

const ScrollingFreeCollectiblesContainerOrganisms: React.FC<
  IScrollingFreeCollectiblesContainerExt & any
> = (props: any) => {
  const router = useRouter();

  // const componentProps = useMemo(
  //   () => handleTypeName({...props, locale: router.locale}),
  //   [props, router.locale]
  // );
  const componentProps = handleTypeName({...props, locale: router.locale});
  const {pathname} = GetRouter();

  const returnPaddingToPathname = (name: string) => {
    switch (name) {
      case '/games/[slug]':
      case '/games':
        return {
          paddingTop: {
            xs: '72px',
            lg: '40px',
          },
          paddingBottom: {
            xs: '72px',
            lg: '40px',
          },
        };

      default:
        return {
          paddingTop: {
            xs: '72px',
            lg: '40px',
          },
          paddingBottom: {
            xs: '72px',
            lg: '40px',
          },
        };
    }
  };

  return (
    <Box sx={returnPaddingToPathname(pathname)}>
      <ScrollingFreeCollectiblesContainer {...componentProps} id={props?.id || ''} />
    </Box>
  );
};

export default ScrollingFreeCollectiblesContainerOrganisms;
